import { passwordLength, usernameLength } from "../../constants";
import * as yup from "yup";
import translate from "../../Utils/translate";

export default yup.object().shape({
  username: yup
    .string()
    .min(usernameLength, translate("validations.username.min", usernameLength))
    .matches(/^[a-z]+/i, translate("validations.username.start_letter"))
    .matches(/^[a-z0-9]*$/i, translate("validations.username.numbers_letters"))
    .required(translate("validations.username.required")),
  password: yup
    .string()
    .required(translate("validations.password.required"))
    .min(passwordLength, translate("validations.password.min", passwordLength))
    .matches(/[a-z]+/, translate("validations.password.lowercase"))
    .matches(/[A-Z]+/, translate("validations.password.uppercase"))
    .matches(/\d+/, translate("validations.password.number"))
    .matches(/[@$!%*#?&]+/, translate("validations.password.special")),
  confirmPassword: yup
    .string()
    .required(translate("validations.confirm_password.required"))
    .test("passwords-match", translate("validations.confirm_password.match"), function (value) {
      return this.parent.password === value;
    }),
  recoveryEmail: yup
    .string()
    .email(translate("validations.recovery_email.not_valid"))
    .required(translate("validations.recovery_email.required")),
});
